import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

import Box, { BoxType } from 'components/Box'
import { Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import { List, ListItem } from 'components/List'
import Section, { SectionType, Size } from 'components/Section/Section'
import { ContentProps } from '../../../data/entries/types'

interface FlavourBoxProps {
  patternImage: string
  content?: ContentProps
  setInfoRef: (ref: HTMLDivElement) => void
}

const FlavourBox: React.FC<FlavourBoxProps> = props => {
  const renderExplain = (leftOrRight: 'left' | 'right') => {
    let length = 5
    if (props.content) {
      if (leftOrRight === 'left' && props.content.explainLeft) {
        length = props.content.explainLeft
      }
      if (leftOrRight === 'right' && props.content.explainRight) {
        length = props.content.explainRight
      }
    }
    const output = []
    for (let i = 1; i <= length; i++) {
      output.push(
        <ListItem dash key={i}>
          <DisplayContent contentKey={`explain-${leftOrRight}-text-${i}`}>
            {`explain-${leftOrRight}-text-${i}`}
          </DisplayContent>
        </ListItem>,
      )
    }
    return output
  }

  return (
    <Section
      type={SectionType.pattern}
      size={Size.m}
      patternImage={props.patternImage}
      sectionRef={props.setInfoRef}
    >
      <Box type={BoxType.flavour}>
        <Grid nrCols={[1, 2]} rowGap={[GridGap.m]}>
          <div>
            <Heading level={4}>
              <DisplayContent contentKey="explain-left-heading">
                What we do for you
              </DisplayContent>
            </Heading>
            <List>{renderExplain('left')}</List>
          </div>
          <div>
            <Heading level={4}>
              <DisplayContent contentKey="explain-right-heading">
                What you need to arrange yourself
              </DisplayContent>
            </Heading>
            <List>{renderExplain('right')}</List>
          </div>
        </Grid>
      </Box>
    </Section>
  )
}

export default FlavourBox
